import { useEntity } from 'hooks/useEntity'
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";
import TopBanner from "layout/TopBanner/TopBanner";
import ViewContextProvider from "features/view/context/ViewContext";
import ViewMonthlyHighlights from "features/monthlyhighlights/components/ViewMonthlyHighlights";

function MonthlyHighlights({ title, hero, path }) {
  const { entity, error } = useEntity(path, 'page');

  useTitle(title);

  if (error) {
    return <Alert/>;
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value || '' }
                 intro={ entity?.field_intro?.value || '' }
                 image={ hero }>
      </TopBanner>
      <div className="wrapper--fluid grid">
        <div className="content content--background">
          <div className="grid">
            { entity?.field_bulletin_category?.id &&
              <ViewContextProvider name={ `bulletin/list/${ entity.field_bulletin_category.id }` }>
                <ViewMonthlyHighlights/>
              </ViewContextProvider>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default MonthlyHighlights;
